<template>
  <article>
    <slot></slot>
  </article>
</template>

<script>
export default {
  name: "Analysis"
};
</script>

<style scoped>
article {
  margin-right: auto;
  margin-left: auto;
  display: block;
}


</style>
